/* eslint-disable no-unused-vars */
import { Col, Row, Select, Spin, Input, Button, message } from "antd";
import React, { useEffect, useState, useCallback } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Moment from "react-moment";

import AWBSuccessModal from "./modals/AWBSuccessModal";
import DraggerModal from "./modals/draggerModal";
import AWBEditModal from "./modals/AWBEditModal";
import ViewBookingSummaryEdit from "../ViewBookingSummaryEdit";
import ViewBookingSummary from "../ViewBookingSummary";
import {
  clearCreatedManifest,
  createManifest,
  getPacketListBySatus,
  getPacketListClear,
  getViewAllBookings,
} from "../../actionsMethods/manifestMethods";

import {
  getBarcodeId,
  getSingleBooking,
} from "../../actionsMethods/cashBookingMethods";

import { column } from "./column";
import { useNavigate } from "react-router-dom";
import TableContainer from "../../components/TableContainer";
import search_icon from "../../assests/images/search-icon.svg";

import truck from "../../assests/images/SVG/packetSurface.svg";
import plane from "../../assests/images/planeicon.svg";

// import truck from "../../assests/images/surface.svg";
// import plane from "../../assests/images/airsurface.svg";
import "./BookingTable.scss";

const BookingTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [editModalvisible, setEditModalvisible] = useState(false);
  const [successModalvisible, setSuccessModalvisible] = useState(false);
  const [oldAwbNum, setOldAwbNum] = useState(null);
  const [uploadModalvisible, setUploadModalvisible] = useState(false);
  const [premiseId, setPremiseId] = useState();
  const [editTest, setEditTest] = useState(false);
  const [manifestFor, setManifestFor] = useState();
  const [dataSource, setDataSource] = useState(data);
  const [inputSearchValue, setInputSearchValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);
  const [dropdownValue, setdropdownValue] = useState(true);
  const [eyeButtonState, setEyeButtonState] = useState(false);
  const [inputState, setInputState] = useState(true);
  const [bookingType, setBookingType] = useState("");
  const { result } = useSelector(
    (state) => state.appReducer.getBarcodeIdReducer,
    shallowEqual
  );

  const viewBookingSummaryResponse = useSelector(
    (state) => state.appReducer.getSingleBookingReducer,
    shallowEqual
  );

  const viewBookingTableResponse = useSelector(
    (state) => state.manifestReducer.getViewAllBookingsReducer,
    shallowEqual
  );

  const createManifestResponse = useSelector(
    (state) => state.manifestReducer.createManifestReducer,
    shallowEqual
  );

  const { result: manifestResult, error: manifestError } =
    createManifestResponse;
  const { result: viewTableResult, fetching } = viewBookingTableResponse;

  const { fetching: loader1, result: packetAndShipment } = useSelector(
    (state) => state.manifestReducer.getPacketListBySatusReducer,
    shallowEqual
  );

  useEffect(() => {
    if (loader1 == false) {
      if (
        packetAndShipment?.packetsdto?.length > 0 ||
        packetAndShipment?.shipmentDto?.length > 0
      ) {
        setdropdownValue(false);
      } else {
        setdropdownValue(true);
      }
    }
  }, [packetAndShipment]);

  useEffect(() => {
    if (manifestError) {
      message.error(manifestError.message);
    } else if (manifestResult) {
      if (manifestFor == "Surface") {
        navigate("/child-scan");
        setdropdownValue(true);
      } else {
        navigate("/viewBooking-packet");
        setdropdownValue(true);
      }

      localStorage.setItem("manifestFor", manifestFor.toLowerCase());
      localStorage.setItem("manifestedId", JSON.stringify(manifestResult));
    }
    return () => {
      dispatch(clearCreatedManifest());
    };
  }, [manifestResult, manifestError]);

  useEffect(() => {
    setPremiseId(JSON.parse(localStorage.getItem("userId")));
  }, []);

  useEffect(() => {
    let data = viewTableResult?.viewBookings?.map((obj) =>
      obj.bookingStatus === "COMPLETED"
        ? { ...obj, bookingStatus: "BOOKED" }
        : obj
    );
    let data2 = { ...viewTableResult, viewBookings: data };

    setData(data2);
  }, [viewTableResult]);

  useEffect(() => {
    dispatch(getViewAllBookings());
  }, [premiseId]);

  const handleUpload = useCallback((val) => {
    setUploadModalvisible(true);
    setOldAwbNum(val.awbNumber);
  });

  function handleCancel() {
    setIsModalOpen(false);
    setIsSummaryModalOpen(false);
    setEditTest(true);
    setInputState(true);
  }

  function MyComponent(dateToFormat) {
    const toUpperCaseFilter = (d) => {
      return d.slice(0, 10);
    };
    return (
      <Moment filter={toUpperCaseFilter} format="DD/MM/YYYY">
        {dateToFormat}
      </Moment>
    );
  }

  function handleEditView(params) {
    setIsModalOpen(true);
    dispatch(getSingleBooking(params?.awbNumber));
    setBookingType(params?.bookingType);
    setEditTest(true);
  }

  const handleEyeButton = (b) => {
    setBookingType(b?.bookingType);
    setIsSummaryModalOpen(true);
    dispatch(getSingleBooking(b?.awbNumber));
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const statusFun = (val) => {
    let color;
    if (val === "BOOKED") {
      color = "stat-green";
    } else if (val === "In progress") {
      color = "blue";
    } else if (val === "Delivered") {
      color = "stat-green";
    } else if (val === "PACKETED") {
      color = "darkBlue";
    } else if (val === "SCANNED") {
      color = "purple";
    } else if (val === "In transit") {
      color = "yellow";
    } else if (val === "MANIFESTED") {
      color = "yellow";
    } else if (val === "OUTSCANNED_TO_CP") {
      color = "yellow";
    }
    return <p className={color}>{val}</p>;
  };

  function handleEdit(val) {
    setOldAwbNum(val.awbNumber);
    let sType = "1";
    if (val?.serviceType === "Fast Track") {
      sType = "2";
      dispatch(getBarcodeId(sType, premiseId?.userInfo?.premiseId));
    }
    if (val?.serviceType === "Value Plus") {
      sType = "3";
      dispatch(getBarcodeId(sType, premiseId?.userInfo?.premiseId));
    }
    if (val?.serviceType === "Standard") {
      sType = "1";
      dispatch(getBarcodeId(sType, premiseId?.userInfo?.premiseId));
    }
    setEditModalvisible(true);
  }

  const filterArray = (dataSource, currValue) =>
    dataSource?.viewBookings.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(currValue.toLowerCase())
      )
    );
  /******************* Input search ******************************/
  const handleChangeSearch = (e) => {
    // const currValue = e.target.value === undefined ? e : e.target.value;
    const currValue = e.target.value;
    setInputSearchValue(currValue);

    const filteredData =
      inputSearchValue.length > 0 || inputSearchValue.length == 0
        ? filterArray(data, currValue)
        : filterArray(data, currValue);
    setDataSource(filteredData);
  };

  /******************* Type ******************************/

  function closeUploadModal() {
    setUploadModalvisible(false);
  }

  function handlePageChange() {
    window.scrollTo(0, 0);
  }

  const handleGenerateManifest = () => {
    let manifestpayload = {
      type: "pickup",
      status: "INITIATED",
      // pickupDriverId: "null",
      travelBy: manifestFor.toUpperCase(),
    };
    dispatch(createManifest(manifestpayload));
  };

  const handleChange = (item) => {
    if (item === "Surface") {
      setManifestFor("Surface");
      dispatch(getPacketListBySatus("manifest", "surface"));
    }
    if (item === "Both") {
      setManifestFor("BOTH");
      setdropdownValue(true);
    }
    if (item === "Air") {
      setManifestFor("Air");
      dispatch(getPacketListBySatus("manifest", "air"));
    }
  };

  useEffect(() => {
    dispatch(getPacketListClear());
  }, []);

  return (
    <Spin spinning={fetching}>
      {/* <AWBEditModal
        oldAwbNum={oldAwbNum}
        visible={editModalvisible}
        handleCancel={closeEditModal}
        handleOk={handleEditOk}
        newAwbNum={result?.data?.awbNumber}
      /> */}
      {/* <AWBSuccessModal
        visible={successModalvisible}
        handleCancel={closeSuccessModal}
        handleOk={handleSuccessOk}
      /> */}
      <ViewBookingSummaryEdit
        visible={isModalOpen}
        handleCancel={handleCancel}
        allAppData={viewBookingSummaryResponse?.result}
        editTest={editTest}
        setEditTest={setEditTest}
        setIsModalOpen={setIsModalOpen}
        setInputState={setInputState}
        inputState={inputState}
        eyeButtonState={eyeButtonState}
        setEyeButtonState={setEyeButtonState}
        bookingType={bookingType}
      />
      <ViewBookingSummary
        visible={isSummaryModalOpen}
        handleCancel={handleCancel}
        allAppData={viewBookingSummaryResponse?.result}
        bookingType={bookingType}
      />

      <DraggerModal
        oldAwbNum={oldAwbNum}
        visible={uploadModalvisible}
        handleCancel={closeUploadModal}
        handleOk={closeUploadModal}
      />

      <div className="table-container">
        <Row justify="space-between" className="row-one">
          <Col lg={20} md={20}>
            <p className="label">Shipment count and weight</p>
          </Col>
          <Col lg={4} md={2} className="generate-manifest">
            <Button
              type="primary"
              onClick={handleGenerateManifest}
              disabled={dropdownValue}
              className="addPacketBtn"
            >
              GENERATE MANIFEST
            </Button>
          </Col>
        </Row>

        <Row className="filter-container">
          <Col className="standard">
            <div>
              <img src={truck} />
              <span>
                {data?.surfaceShipmentNo}/
                {data?.surfaceShipmentWeight?.toFixed(2)}kg
              </span>
            </div>
          </Col>
          <Col className="fast-track">
            <div>
              <img src={plane} />
              <span>
                {data?.airShipmentNo}/{data?.atrShipmentWeight?.toFixed(2)}
                kg
              </span>
            </div>
          </Col>
          <Col className="stand-fast" md={6} lg={6}>
            <div>
              <img src={truck} /> + <img src={plane} />
              <span className="span-2">
                Consolidated weight :{" "}
                {data?.airShipmentNo + data?.surfaceShipmentNo}/
                {(
                  data?.atrShipmentWeight + data?.surfaceShipmentWeight
                ).toFixed(2)}
                kg
              </span>
            </div>
          </Col>
          <Col className="select-type">
            <Select
              // defaultValue={""}
              placeholder="Select mode"
              onChange={handleChange}
              options={[
                {
                  value: "Surface",
                  label: "Surface",
                },
                {
                  value: "Air",
                  label: "Air",
                },
                {
                  value: "Both",
                  label: "Both",
                },
              ]}
            />
          </Col>
          <Col className="search-box">
            <Input
              placeholder="Search by Awb No, type, mode"
              bordered
              onChange={(e) => handleChangeSearch(e)}
              style={{ borderRadius: "5px", height: "40px" }}
              suffix={<img src={search_icon} />}
            />
          </Col>
        </Row>
        <TableContainer
          columns={column(
            MyComponent,
            statusFun,
            handleEdit,
            handleEditView,
            handleUpload,
            handleEyeButton
          )}
          scroll={{
            x: 100,
            y: 400,
          }}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} items`
          }
          pagination={{
            pageSize: 10,
            total:
              inputSearchValue.length == 0
                ? data?.viewBookings?.length
                : dataSource.length,
            onChange: handlePageChange,
            itemRender: itemRender,
          }}
          total={data?.viewBookings?.length}
          defaultCurrent={1}
          dataSource={
            inputSearchValue.length == 0 ? data?.viewBookings : dataSource
          }
          headerClassName="header"
          className="view-table"
        />
      </div>
    </Spin>
  );
};

export default React.memo(BookingTable);
